// todo except children other than a string | nil
import React from "react";

const LineIf = ({text, br = true, ...props}) =>
    (text || '').trim() && <span {...props}>{text}{br && <br/>}</span>

const wrap = {overflowWrap: 'break-word', wordWrap: 'break-word'};

export function CompanyInfo({company = {}, alternateName, style, ...props}) {
    const {name, address1, city, state, zip, web, phone} = company;

    return <div style={{...wrap, ...style}} {...props}>
        <span>
            <span style={{fontWeight: 'bold'}}>{name}</span>
            {alternateName && (alternateName !== alternateName) &&
            <span><br/>({name})</span>}
            <br/>
        </span>
        <LineIf text={address1}/>
        <LineIf text={(city || '') + ' ' + (state || '') + ' ' + (zip || '')}/>
        <LineIf text={web}/>
        <LineIf text={phone}/>
    </div>
}